exports = module.exports = require("../../../../../../../shared/rnclient/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".favorite-button--button--GztiO0k3 {\n  padding: 0 7px;\n}\n\n.favorite-button--button--GztiO0k3[class~=favorite] .favorite-button--icon--ohOxQo7Y {\n  color: #FFCC00!important;\n}\n\n.favorite-button--icon--ohOxQo7Y {\n  font-size: 140%!important;\n  color: #888;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/favorite-button.css"],"names":[],"mappings":"AAAA;EACE,eAAe;CAChB;;AAED;EACE,yBAAyB;CAC1B;;AAED;EACE,0BAA0B;EAC1B,YAAY;CACb","file":"favorite-button.css","sourcesContent":[".button {\n  padding: 0 7px;\n}\n\n.button[class~=favorite] .icon {\n  color: #FFCC00!important;\n}\n\n.icon {\n  font-size: 140%!important;\n  color: #888;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"button": "favorite-button--button--GztiO0k3",
	"icon": "favorite-button--icon--ohOxQo7Y"
};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!/home/deploy/gamba/shared/rnclient/node_modules/postcss-loader/lib!./src/web/components/themes/favorite-button.css
// module id = 2594
// module chunks = 4